import { ClientUserRelationship, UserTypeEnum } from '@app/enum/UserTypeEnum';
import { createSelector } from '@ngrx/store';
import { of } from 'rxjs';
import { RelationshipStoreModule } from './relationship-store.module';
function sort_by_key(array, key) {
  return array.sort(function (a, b) {
    const x = a[key];
    const y = b[key];
    return x < y ? -1 : x > y ? 1 : 0;
  });
}

function groupBy(xs, key) {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
}
function sortByAlphBaticOrder(allItems, type) {
  const result = [];
  allItems = allItems.slice().sort(function (a, b) {
    a = a.user_first_middle_name;
    b = b.user_first_middle_name;
    a = a.trim().toLowerCase();
    b = b.trim().toLowerCase();

    return a < b ? -1 : a > b ? 1 : 0;
  });
  if (type == 'DSC') {
    allItems = allItems.reverse();
  }
  // let groupedData = groupBy(allItems, 'connection_status');
  // let sortArrangement = ['invited', 'pending', 'approved'];
  // sortArrangement.map((item) => {
  //   if (groupedData[item]) {
  //     groupedData[item].forEach((x) => {
  //       result.push(x);
  //     });
  //   }
  // });

  return allItems;
}
function custom_sort(a, b) {
  return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
}
function sortByCrteateDate(allItems) {
  const result = [];
  allItems = allItems.slice().sort(custom_sort);
  // let groupedData = groupBy(allItems, 'connection_status');
  // let sortArrangement = ['invited', 'pending', 'approved'];
  // sortArrangement.map((item) => {
  //   if (groupedData[item]) {
  //     groupedData[item].forEach((x) => {
  //       result.push(x);
  //     });
  //   }
  // });

  return allItems;
}

function sortClientGroupByCreateDate(allItems) {
  return (allItems = allItems.slice().sort(custom_sort));
}

function sortClientGroupByAlphbeticOrder(allItems, type) {
  allItems = allItems.slice().sort(function (a, b) {
    a = a.name;
    b = b.name;
    a = a.toLowerCase();
    b = b.toLowerCase();

    return a < b ? -1 : a > b ? 1 : 0;
  });

  if (type == 'ASC') {
    return allItems;
  }
  if (type == 'DSC') {
    return allItems.reverse();
  }
}

export const selectItems = (state: RelationshipStoreModule) =>
  state.Relationship && state.Relationship.allRelationships ? state.Relationship.allRelationships : null;

export const selectImpersonateItems = (state: RelationshipStoreModule) =>
  state.Relationship && state.Relationship.impersonateUserListForReport ? state.Relationship.impersonateUserListForReport : null;

export const selectGroupClients = (state: RelationshipStoreModule) =>
  state.Relationship && state.Relationship.allClientGroups ? state.Relationship.allClientGroups : null;
export const selectMySuggestions = (state: RelationshipStoreModule) => state.Relationship.MySuggestions;

export const getrelationshipnameByuserId = (id) =>
  createSelector(selectItems, (allItems) => {
    {
      if (allItems != null && allItems.findIndex((x) => x.user_id == id) != -1) {
        return { relationship_name: allItems[allItems.findIndex((x) => x.user_id == id)].relationship_name };
      } else {
        return { relationship_name: '' };
      }
    }
  });

export const getRelationshipUserNameByuserId = (id) =>
  createSelector(selectItems, (allItems) => {
    {
      if (allItems != null && allItems.findIndex((x) => x.user_id == id) != -1) {
        return {
          name:
            allItems[allItems.findIndex((x) => x.user_id == id)].user_first_middle_name +
            ' ' +
            allItems[allItems.findIndex((x) => x.user_id == id)].user_last_name,
        };
      } else {
        return { name: '' };
      }
    }
  });

export const givenPremiumLancesName = (id) =>
  createSelector(selectItems, (allItems) => {
    {
      if (allItems != null && allItems.findIndex((x) => x.user_id == id) != -1) {
        return allItems[allItems.findIndex((x) => x.user_id == id)];
      } else {
        return {};
      }
    }
  });
export const getRequestRelationship = (id: string, isProfessional: boolean) =>
  createSelector(selectItems, (allItems) => {
    {
      if (allItems == null || allItems == undefined) {
        return [];
      }

      if (isProfessional) {
        allItems = allItems.filter(
          (connection) =>
            connection.to_user_id == id && connection.connection_status == 'pending' && connection.user_type == UserTypeEnum.Professional
        );
      } else {
        allItems = allItems.filter(
          (connection) =>
            connection.to_user_id == id && connection.connection_status == 'pending' && connection.user_type != UserTypeEnum.Professional
        );
      }

      return allItems;
    }
  });

export const getRequestAllRelationship = (id: string, isProfessional: boolean) =>
  createSelector(selectItems, (allItems) => {
    {
      if (allItems == null || allItems == undefined) {
        return [];
      }

      allItems = allItems.filter((connection) => connection.to_user_id == id && connection.connection_status == 'pending');

      return allItems;
    }
  });

export const getRequestAllRelationshipWithFilter = (id: string, isProfessional: boolean) =>
  createSelector(selectItems, (allItems) => {
    {
      if (allItems == null || allItems == undefined) {
        return [];
      }

      if (isProfessional) {
        allItems = allItems.filter(
          (connection) =>
            connection.to_user_id == id && connection.connection_status == 'pending' && connection.user_type.toLowerCase() == 'professional'
        );
      } else {
        allItems = allItems.filter(
          (connection) =>
            connection.to_user_id == id && connection.connection_status == 'pending' && connection.user_type.toLowerCase() != 'professional'
        );
      }

      return allItems;
    }
  });
export const getRequestAllRelationshipProf = (id: string, isProfessional: boolean) =>
  createSelector(selectItems, (allItems) => {
    {
      if (allItems == null || allItems == undefined) {
        return [];
      }

      allItems = allItems.filter(
        (connection) =>
          connection.to_user_id == id && connection.connection_status == 'pending' && connection.user_type.toLowerCase() == 'professional'
      );

      return allItems;
    }
  });

// New selector that returns all pending requests regardless of user type
export const getAllPendingRequests = (id: string) =>
  createSelector(selectItems, (allItems) => {
    {
      if (allItems == null || allItems == undefined) {
        return [];
      }

      // Return all pending requests regardless of user type
      allItems = allItems.filter(
        (connection) =>
          connection.to_user_id == id && connection.connection_status == 'pending'
      );

      return allItems;
    }
  });

export const getAllRelationShipSelectorPersonal = (id: string, isProfessional: boolean) =>
  createSelector(selectItems, (allItems) => {
    {
      let finaldata = [];
      allItems.forEach((element, index) => {
        const test = JSON.parse(JSON.stringify(allItems[index]));
        test.isExistingUser = false;
        // test.connection_status = 'invite';
        Object.preventExtensions(test);
        if (isProfessional) {
          if (test.user_type == UserTypeEnum.Professional) {
            finaldata.push(test);
          }
        } else {
          if (test.user_type != UserTypeEnum.Professional) {
            finaldata.push(test);
          }
        }
      });
      finaldata = sort_by_key(finaldata, 'full_name');

      return finaldata;
    }
  });
export const getAllRelationShipWithApprovedCounterSelector = (id: string, isProfessional: boolean) =>
  createSelector(selectItems, (allItems) => {
    {
      let finaldata = [];
      if (allItems != null && allItems != undefined && allItems.length) {
        allItems.forEach((element, index) => {
          const test = JSON.parse(JSON.stringify(allItems[index]));
          test.isExistingUser = false;
          // test.connection_status = 'invite';
          Object.preventExtensions(test);
          if (isProfessional) {
            if (test.user_type == UserTypeEnum.Professional) {
              if (test.connection_status == 'approved') {
                finaldata.push(test);
              }
            }
          } else {
            if (test.user_type != UserTypeEnum.Professional) {
              if (test.connection_status == 'approved') {
                finaldata.push(test);
              }
            }
          }
        });
        finaldata = sort_by_key(finaldata, 'full_name');
      }
      return finaldata.length;
    }
  });

export const getAllRelationShipPersonalProfessionalSelector = (id: string) =>
  createSelector(selectItems, (allItems) => {
    {
      let finaldata = [];

      if (allItems != null && allItems != undefined && allItems.length) {
        allItems.forEach((element, index) => {
          const test = JSON.parse(JSON.stringify(allItems[index]));
          test.isExistingUser = false;
          // test.connection_status = 'invite';
          Object.preventExtensions(test);
          if (test.connection_status == 'pending' && test.to_user_id == id) {
          } else {
            finaldata.push(test);
          }
        });
        finaldata = sort_by_key(finaldata, 'full_name');
      }
      return finaldata;
    }
  });
export const getAllRelationShipSelector = (id: string, isProfessional: boolean) =>
  createSelector(selectItems, (allItems) => {
    {
      let finaldata = [];

      if (allItems != null && allItems != undefined && allItems.length) {
        allItems.forEach((element, index) => {
          const test = JSON.parse(JSON.stringify(allItems[index]));
          test.isExistingUser = false;
          // test.connection_status = 'invite';
          Object.preventExtensions(test);
          if (test.connection_status == 'pending' && test.to_user_id == id) {
          } else {
            if (isProfessional) {
              if (test.user_type == UserTypeEnum.Professional) {
                finaldata.push(test);
              }
            } else {
              if (test.user_type != UserTypeEnum.Professional) {
                finaldata.push(test);
              }
            }
          }
        });
        finaldata = sort_by_key(finaldata, 'full_name');
      }
      return finaldata;
    }
  });
export const getAllRelationShipSortProfessinalSelector = (id: string, sortType: string, filterString: String) =>
  createSelector(selectItems, (allItems) => {
    {
      const finaldata = [];
      if (allItems == null || allItems == undefined) {
        return [];
      }
      allItems = allItems.filter((x) => x.relationship_id == '21' && x.relationship_name.toLowerCase() == 'professional');

      if (allItems.length == 0) {
        return [];
      }
      if (sortType == 'A-Z') {
        allItems = sortByAlphBaticOrder(allItems, 'ASC');
      } else if (sortType == 'Z-A') {
        allItems = sortByAlphBaticOrder(allItems, 'DSC');
      } else {
        allItems = sortByCrteateDate(allItems);
      }
      if (filterString != '' && filterString != null && filterString != undefined && filterString.length > 0) {
        const finaldata = [];
        allItems.forEach((element) => {
          if (
            element.user_first_middle_name.toLocaleLowerCase().includes(filterString.toLocaleLowerCase()) ||
            element.user_last_name.toLocaleLowerCase().includes(filterString.toLocaleLowerCase())
          ) {
            finaldata.push(element);
          }
        });
        return finaldata;
      }

      return allItems;
    }
  });

export const getAllProfessionalRelationShipSortSelector = () =>
  createSelector(selectItems, (allItems) => {
    return allItems;
  });
export const getAllRelationShipSortSelector = (id: string, sortType: string, filterString: String, isProfessional: boolean = false) =>
  createSelector(selectItems, (allItems) => {
    {
      if (!allItems) {
        return [];
      }

      // Previously filtered by user_type. Now we show both Professional and Family together.
      if (sortType == 'A-Z') {
        allItems = sortByAlphBaticOrder(allItems, 'ASC');
      } else if (sortType == 'Z-A') {
        allItems = sortByAlphBaticOrder(allItems, 'DSC');
      } else {
        allItems = sortByCrteateDate(allItems);
      }
      if (filterString && filterString.length > 0) {
        const finaldata = [];
        allItems.forEach((element) => {
          const full_name: string = `${element.user_first_middle_name.trim()} ${element.user_last_name.trim()}`;
          if (full_name.toLowerCase().includes(filterString.toLowerCase())) {
            finaldata.push(element);
          }
          // if (
          //   element.user_first_middle_name.toLocaleLowerCase().includes(filterString.toLocaleLowerCase()) ||
          //   element.user_last_name.toLocaleLowerCase().includes(filterString.toLocaleLowerCase())
          // ) {
          //   finaldata.push(element);
          // }
        });
        return finaldata;
      }

      return allItems;
    }
  });

export const getAllClientGroupsSortSelector = (id: string, sortType: string, filterString: String, isProfessional: boolean = false) =>
  createSelector(selectGroupClients, (allItems) => {
    {
      const finaldata = [];
      if (allItems == null || allItems == undefined) {
        return [];
      }

      if (sortType == 'A-Z') {
        allItems = sortClientGroupByAlphbeticOrder(allItems, 'ASC');
      } else if (sortType == 'Z-A') {
        allItems = sortClientGroupByAlphbeticOrder(allItems, 'DSC');
      } else {
        allItems = sortClientGroupByCreateDate(allItems);
      }

      if (filterString != '' && filterString != null && filterString != undefined && filterString.length > 0) {
        const finaldata = [];

        allItems.forEach((element) => {
          if (element.name.toLocaleLowerCase().includes(filterString.toLocaleLowerCase())) {
            finaldata.push(element);
          }

          element.networkClientGroupClients.forEach((client) => {
            if (client.clientUser.name.toLocaleLowerCase().includes(filterString.toLocaleLowerCase())) {
              finaldata.push(element);
            }
          });
        });

        return finaldata;
      } else {
        return allItems;
      }
    }
  });

export const getrelationshipnameListChecklist = (CurrentItemList) =>
  createSelector(selectItems, (allItems) => {
    {
      const returnList = [];
      if (allItems != null && CurrentItemList != null) {
        CurrentItemList.forEach((element, index) => {
          if (allItems.findIndex((x) => x.user_id == CurrentItemList[index].shared_with_user_id) != -1) {
            const test = JSON.parse(JSON.stringify(CurrentItemList[index]));
            test.relationship_name = allItems[allItems.findIndex((x) => x.user_id == CurrentItemList[index].shared_with_user_id)].relationship_name;
            test.connection_status = allItems[allItems.findIndex((x) => x.user_id == CurrentItemList[index].shared_with_user_id)].connection_status;
            test.from_user_id = allItems[allItems.findIndex((x) => x.user_id == CurrentItemList[index].shared_with_user_id)].from_user_id;
            Object.preventExtensions(test);
            returnList.push(test);
          } else {
            returnList.push(element);
          }
        });
        return returnList;
      } else {
        return CurrentItemList;
      }
    }
  });

export const getrelationshipnameList = (CurrentItemList) =>
  createSelector(selectItems, (allItems) => {
    {
      const returnList = [];
      if (allItems != null && CurrentItemList != null) {
        CurrentItemList.forEach((element, index) => {
          if (allItems.findIndex((x) => x.user_id == CurrentItemList[index].user_id) != -1) {
            const test = JSON.parse(JSON.stringify(CurrentItemList[index]));
            test.relationship_name = allItems[allItems.findIndex((x) => x.user_id == CurrentItemList[index].user_id)].relationship_name;
            test.connection_status = allItems[allItems.findIndex((x) => x.user_id == CurrentItemList[index].user_id)].connection_status;
            test.from_user_id = allItems[allItems.findIndex((x) => x.user_id == CurrentItemList[index].user_id)].from_user_id;
            Object.preventExtensions(test);
            returnList.push(test);
          } else {
            returnList.push(element);
          }
        });
        return returnList;
      } else {
        return CurrentItemList;
      }
    }
  });

export const getAprovedUserList = () =>
  createSelector(selectItems, (allItems) => {
    {
      if (allItems != null) {
        const data = allItems.filter((x) => x.connection_status == 'approved');
        return data;
      }
      return [];
    }
  });
export const getAprovedUserListWithNonprofessional = () =>
  createSelector(selectItems, (allItems) => {
    {
      if (allItems != null) {
        const data = allItems.filter((x) => x.connection_status == 'approved' && x.relationship_id != ClientUserRelationship.id);
        return data;
      }
      return [];
    }
  });
export const getAllClientListWithApprovedPending = () =>
  createSelector(selectItems, (allItems) => {
    if (allItems != null) {
      const data = allItems.filter((x) => x.user_type != UserTypeEnum.Professional);
      return data;
    }
    return [];
  });

export const getOnlyProfessional = (existingUsers) =>
  createSelector(selectItems, (allItems) => {
    let templist = [];
    let finalyallitem = [];
    {
      if (allItems != null) {
        templist = allItems.filter((x) => x.user_type == UserTypeEnum.Professional);

        if (existingUsers.length > 0 && templist.length > 0) {
          templist.forEach((element) => {
            if (existingUsers.findIndex((x) => x.sharedUser.id == element.user_id) == -1) {
              finalyallitem.push(element);
            }
          });
        } else {
          finalyallitem = templist;
        }
      }

      return finalyallitem;
    }
  });
export const getAllUserListWithApprovedPending = () =>
  createSelector(selectItems, (allItems) => {
    {
      if (allItems != null) {
        return allItems;
      }
      return [];
    }
  });
export const getAllProfessionalnoparameter = () =>
  createSelector(selectItems, (allItems) => {
    {
      if (allItems != null) {
        const data = allItems.filter((x) => x.user_type == UserTypeEnum.Professional);
        return data;
      }
      return [];
    }
  });

export const getAllNonProfessional = () =>
  createSelector(selectItems, (allItems) => {
    {
      if (allItems != null) {
        const data = allItems.filter((x) => x.user_type != UserTypeEnum.Professional);
        return data;
      }
      return [];
    }
  });

export const filteredRelationshipsForWorkspace = (workspaceData: any, fullGroupList: any, value?: any) =>
  createSelector(selectItems, (allItems) => {
    //get the distinct list of all clients assigned to this workspace
    const clientList = [];
    workspaceData.forEach((workspaceItem) => {
      workspaceItem.officeWorkspaceClients.forEach((client) => {
        clientList.push(client.user_id);
      });
    });

    //get the SET difference between relationships and clientsList
    // let workspaceClient = allItems.filter((x) => x.user_type != UserTypeEnum.Professional).filter((x) => !clientList.includes(parseInt(x.user_id)));

    let workspaceClient = allItems.filter((x) => x.user_type != UserTypeEnum.Professional);

    if (fullGroupList?.length) {
      workspaceClient = workspaceClient.concat(fullGroupList);
    }

    if (value) {
      workspaceClient = workspaceClient.filter((relationship) => {
        const relationshipName = relationship.user_first_middle_name + ' ' + relationship.user_last_name;
        return relationshipName?.toLowerCase()?.includes(value.toLowerCase());
      });
    }
    workspaceClient = workspaceClient.slice().sort(function (a, b) {
      a = a.user_first_middle_name;
      b = b.user_first_middle_name;
      a = a.toLowerCase();
      b = b.toLowerCase();
      return a > b ? -1 : a > b ? 1 : 0;
    });

    return workspaceClient;
  });

export const getAndFilterAllUsers = (value?: any) =>
  createSelector(selectItems, (allItems) => {
    if (value) {
      return allItems.filter((relationship) => {
        const relationshipName = relationship.user_first_middle_name + ' ' + relationship.user_last_name;
        return relationshipName?.toLowerCase()?.includes(value.toLowerCase());
      });
    } else {
      return allItems;
    }
  });
export const getAndFilterAllImpersonatesUsers = (value?: any) =>
  createSelector(selectImpersonateItems, (allItems) => {
    if (value) {
      return allItems.filter((relationship) => {
        const relationshipName = relationship.user_first_middle_name + ' ' + relationship.user_last_name;
        return relationshipName?.toLowerCase()?.includes(value.toLowerCase());
      });
    } else {
      return allItems;
    }
  });
export const getAndFilterNonProfessionalExcludeExistingUser = (value?: any, existingUsers?: any, isFromClientGroup?: boolean) =>
  createSelector(selectItems, (allItems) => {
    let templist = [];
    let finalyallitem = [];
    if (value) {
      templist = allItems
        .filter((x) => x.user_type != UserTypeEnum.Professional)
        .filter((relationship) => {
          const relationshipName = relationship.user_first_middle_name + ' ' + relationship.user_last_name;
          return relationshipName?.toLowerCase()?.includes(value.toLowerCase());
        });
    } else {
      templist = allItems.filter((x) => x.user_type != UserTypeEnum.Professional);
    }
    if (existingUsers.length > 0 && templist.length > 0) {
      if (isFromClientGroup) {
        templist.forEach((element) => {
          if (existingUsers.findIndex((x) => x.client_id == element.user_id) == -1) {
            finalyallitem.push(element);
          }
        });
      } else {
        templist.forEach((element) => {
          if (existingUsers.findIndex((x) => x.user_id == element.user_id) == -1) {
            finalyallitem.push(element);
          }
        });
      }
    } else {
      finalyallitem = templist;
    }

    return finalyallitem;
  });

export const getAndFilterAllUsersExcludeExstingUser = (value?: any, existingUsers?: any) =>
  createSelector(selectItems, (allItems) => {
    let templist = [];
    let finalyallitem = [];
    if (value) {
      templist = allItems.filter((relationship) => {
        const relationshipName = relationship.user_first_middle_name + ' ' + relationship.user_last_name;
        return relationshipName?.toLowerCase()?.includes(value.toLowerCase());
      });
    } else {
      templist = allItems;
    }
    if (existingUsers.length > 0 && templist.length > 0) {
      templist.forEach((element) => {
        if (existingUsers.findIndex((x) => x.user_id == element.user_id) == -1) {
          finalyallitem.push(element);
        }
      });
    } else {
      finalyallitem = templist;
    }
    return finalyallitem;
  });

export const getAllProfessionalWithGroupsFilter = (FullGruupList: any, client: any, selectedMember, existingUsers, value?: any) =>
  createSelector(selectItems, (allItems) => {
    const allItemsFiltered = [
      ...allItems.filter((user) => user.user_id != selectedMember.id).filter((x) => x.user_type == UserTypeEnum.Professional),
      ...(client || []),
    ];

    let templist = [];
    let finalyallitem = [];
    if (value) {
      templist = allItemsFiltered.filter((relationship) => {
        const relationshipName = relationship.user_first_middle_name + ' ' + relationship.user_last_name;
        return relationshipName?.toLowerCase()?.includes(value.toLowerCase());
      });
    } else {
      templist = allItemsFiltered;
    }
    if (existingUsers.length > 0 && templist.length > 0) {
      templist.forEach((element) => {
        if (element?.isGroup) {
          if (existingUsers.findIndex((x) => x.user_id == element.id) == -1) {
            finalyallitem.push(element);
          }
        } else {
          if (existingUsers.findIndex((x) => x.user_id == element.user_id) == -1) {
            finalyallitem.push(element);
          }
        }
      });
    } else {
      finalyallitem = templist;
    }
    return finalyallitem;
  });

// export const getAllProfessionalWithGroupsFilter = (FullGruupList: any, client: any, selectedMember, existingUsers, value?: any) =>
//   createSelector(selectItems, (allItems) => {
//     const allItemsFiltered = [
//       ...allItems.filter((user) => user.user_id != selectedMember.id).filter((x) => x.user_type == UserTypeEnum.Professional),
//       ...(client || []),
//     ];

//     let templist = [];
//     let finalyallitem = [];
//     if (value) {
//       templist = allItemsFiltered.filter((relationship) => {
//         const relationshipName = relationship.user_first_middle_name + ' ' + relationship.user_last_name;
//         return relationshipName?.toLowerCase()?.includes(value.toLowerCase());
//       });
//     } else {
//       templist = allItemsFiltered;
//     }
//     // if (existingUsers.length > 0 && templist.length > 0) {
//     //   templist.forEach((element) => {
//     //     if (existingUsers.findIndex((x) => x.user_id == element.user_id) == -1) {
//     //       finalyallitem.push(element);
//     //     }
//     //   });
//     // } else {
//     //   finalyallitem = templist;
//     // }
//     // let finalGrupdData = [];
//     // if (FullGruupList?.length) {
//     //   FullGruupList.forEach((element, index) => {
//     //     if (existingUsers?.length > 0) {
//     //       if (existingUsers.findIndex((x) => x.id == element.id && x.memberUser?.isGroup) == -1) {
//     //         finalGrupdData.push(element);
//     //       }
//     //     } else {
//     //       finalGrupdData.push(element);
//     //     }

//     //   });
//     // }

//     // finalyallitem = finalyallitem.concat(finalGrupdData)
//     finalyallitem = finalyallitem.slice().sort(function (a, b) {
//       a = a.user_first_middle_name;
//       b = b.user_first_middle_name;
//       a = a.toLowerCase();
//       b = b.toLowerCase();
//       return a > b ? -1 : a > b ? 1 : 0;
//     });
//     return finalyallitem;
//   });
export const getAllProfessional = (client: any = null, selectedMember, existingUsers, value?: any) =>
  createSelector(selectItems, (allItems) => {
    let allItemsFiltered = [...allItems.filter((user) => user.user_id != selectedMember.id).filter((x) => x.user_type == UserTypeEnum.Professional)];
    if (client != null) {
      allItemsFiltered = allItemsFiltered.concat([client]);
    }

    let templist = [];
    let finalyallitem = [];
    if (value) {
      templist = allItemsFiltered.filter((relationship) => {
        const relationshipName = relationship.user_first_middle_name + ' ' + relationship.user_last_name;
        return relationshipName?.toLowerCase()?.includes(value.toLowerCase());
      });
    } else {
      templist = allItemsFiltered;
    }
    if (existingUsers.length > 0 && templist.length > 0) {
      templist.forEach((element) => {
        if (element?.isGroup) {
          if (existingUsers.findIndex((x) => x.network_client_group_id == element.id) == -1) {
            finalyallitem.push(element);
          }
        } else {
          if (existingUsers.findIndex((x) => x.user_id == element.user_id) == -1) {
            finalyallitem.push(element);
          }
        }
      });
    } else {
      finalyallitem = templist;
    }
    return finalyallitem;
  });

export const getNameAndProfileUrl = (userId) =>
  createSelector(selectItems, (allItems) => {
    {
      if (allItems != null && allItems.findIndex((x) => x.user_id == userId) != -1) {
        return {
          first_name: allItems[allItems.findIndex((x) => x.user_id == userId)].user_first_middle_name,
          last_name: allItems[allItems.findIndex((x) => x.user_id == userId)].user_last_name,
          profile_image_url: allItems[allItems.findIndex((x) => x.user_id == userId)].user_profile_image_url,
          connection_status: allItems[allItems.findIndex((x) => x.user_id == userId)].connection_status,
        };
      } else {
        return { first_name: '', last_name: '', profile_image_url: null };
      }
    }
  });

export const getCurrentRelationshipDetail = (userId) =>
  createSelector(selectItems, (allItems) => {
    {
      if (allItems != null && allItems.findIndex((x) => x.to_user_id === userId) != -1) {
        const user = allItems.filter((x) => x.to_user_id === userId);
        return user;
      } else {
        return {};
      }
    }
  });

/**
 * Selector to get all relationships
 */
export const getAllRelationshipsSelector = () =>
  createSelector(selectItems, (allItems) => {
    const removeDuplicate = allItems.filter((v, i, a) => a.findIndex((v2) => v2?.user_id === v?.user_id) == i);
    return removeDuplicate;
  });

// Selector to get family type relationships
export const getFamilyTypeRelationship = (existingUsers) =>
  createSelector(
    selectItems,
    (allItems) => allItems?.filter((element) => existingUsers?.some((x) => x.id === Number(element.relationship_id) && x.is_family === 'y')) || []
  );

// Selector to get friend type relationships
export const getFriendTypeRelationship = (existingUsers) =>
  createSelector(
    selectItems,
    (allItems) => allItems?.filter((element) => existingUsers?.some((x) => x.id === Number(element.relationship_id) && x.is_friend === 'y')) || []
  );

// Selector to get professional type relationships
export const getProfessionalTypeRelationship = (existingUsers) =>
  createSelector(
    selectItems,
    (allItems) =>
      allItems?.filter((element) => existingUsers?.some((x) => x.id === Number(element.relationship_id) && x.is_professional === 'y')) || []
  );

export const getProfessionalRequestRelationship = (isProfessional: boolean) =>
  createSelector(selectItems, (allItems) => {
    {
      if (allItems == null || allItems == undefined) {
        return [];
      }

      if (isProfessional) {
        allItems = allItems.filter((connection) => connection.connection_status == 'pending' && connection.user_type == UserTypeEnum.Professional);
      } else {
        allItems = allItems.filter((connection) => connection.connection_status == 'pending' && connection.user_type != UserTypeEnum.Professional);
      }

      return allItems;
    }
  });
export const selectLoading = (state: RelationshipStoreModule) => state.Relationship.allRelationshipListLoading;

export const getAndFilterProfessionalExcludeExistingUser = (value?: any, existingUsers?: any, isFromClientGroup?: boolean) =>
  createSelector(selectItems, (allItems) => {
    let templist = [];
    let finalyallitem = [];
    if (value) {
      templist = allItems
        .filter((x) => x.user_type == UserTypeEnum.Professional)
        .filter((relationship) => {
          const relationshipName = relationship.user_first_middle_name + ' ' + relationship.user_last_name;
          return relationshipName?.toLowerCase()?.includes(value.toLowerCase());
        });
    } else {
      templist = allItems.filter((x) => x.user_type == UserTypeEnum.Professional);
    }
    if (existingUsers.length > 0 && templist.length > 0) {
      if (isFromClientGroup) {
        templist.forEach((element) => {
          if (existingUsers.findIndex((x) => x.client_id == element.user_id) == -1) {
            finalyallitem.push(element);
          }
        });
      } else {
        templist.forEach((element) => {
          if (existingUsers.findIndex((x) => x.user_id == element.user_id) == -1) {
            finalyallitem.push(element);
          }
        });
      }
    } else {
      finalyallitem = templist;
    }

    return finalyallitem;
  });
